<app-phx-input-datepicker
    #datepicker
    ngDefaultControl
    [formControl]="formControl"
    [formlyAttributes]="field"
    [(value)]="value"
    [disabled]="formControl?.disabled"
    [timeOnly]="timeOnly()"
    [withTime]="showTime()"
    [showSeconds]="showSeconds()"
    (onClear)="onClear()"
/>
